import { useContext } from 'react';
import { gql, useQuery } from '@apollo/client';
import {
  Box, Skeleton, Typography,
} from '../../../../1-primative';
import { Card } from '../../../../2-component';
import { UserContext } from '../../../../../providers/userContextProvider';
import { useThemeTokens } from '../../../../../providers/themeTokenProvider';
import { formatMoneyValue, formatPercentValue } from '../../../../../util';

const FETCH_MARKET_DATA = gql`
  query FetchMarketDataFromProvider($input: FetchMarketDataFromProviderInput!) {
    fetchMarketDataFromProvider(input: $input) {
      marketData {
        shortName
        ticker
        exchange
        currency
        statistics {
          changeCents
          changePercent
          lastCents
        }
      }
    }
  }
`;

export const MarketDataTicker = ({
  options = {
    tickers: '',
  },
}: {
  options: {
    tickers: string;
  };
}) => {
  const { tickers } = options;
  const { activeOrganization } = useContext(UserContext);
  const { sys } = useThemeTokens();

  const { data, loading } = useQuery(FETCH_MARKET_DATA, {
    variables: {
      input: {
        organizationId: activeOrganization.id,
        tickers,
      },
    },
  });

  const findMarketData = (ticker: string) => data?.fetchMarketDataFromProvider?.marketData?.find((marketData: any) => marketData.ticker === ticker) || {
    shortName: ticker,
    ticker,
    exchange: '',
    currency: '',
    statistics: {
      changeCents: 0,
      changePercent: 0,
      lastCents: 0,
    },
  };

  return (
    <Card>
      <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
        {tickers.split(',').map((ticker: any) => (
          <Box
            sx={{ '&:not(:last-of-type)': { borderRight: `1px solid ${sys.color.outlineVariant}` }, p: 2 }}
            display='flex'
            flexDirection='column'
            flex={1}
            key={ticker}
            alignItems='start'
            width='100%'
            justifyContent='space-between'
          >
            { loading ? (
              <Skeleton variant='text' width='70%' height='24px' />
            ) : (
              <Typography variant='bodyLarge' weight='bold'>{findMarketData(ticker)?.shortName}</Typography>
            )}
            { loading ? (
              <Box display='flex' justifyContent='space-between' width='100%'>
                <Skeleton variant='text' width='80px' height='20px' />
                <Skeleton variant='text' width='45px' height='20px' />
              </Box>
            ) : (
              <Box display='flex' justifyContent='space-between' width='100%'>
                <Typography colorVariant='variant' variant='bodyMedium'>{formatMoneyValue(findMarketData(ticker).statistics.lastCents)} {findMarketData(ticker).currency}</Typography>
                <Typography variant='bodyMedium' sx={{ color: findMarketData(ticker).statistics.changePercent > 0 ? sys.color.positive : sys.color.negative }}>
                  {findMarketData(ticker).statistics.changePercent > 0 ? '+' : ''}{formatPercentValue((findMarketData(ticker).statistics.changePercent / 100), 2)}
                </Typography>
              </Box>
            )}
          </Box>
        ))}
      </Box>
    </Card>
  );
};
